import { arrayOf, bool, func, oneOf, oneOfType, shape } from 'prop-types'
import { Component } from 'react'

import { ACTIVE_TENANTS } from 'views/consts/tenants'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

class Tenant extends Component {
  static propTypes = {
    children: func.isRequired,
    not: bool,
    tenant: oneOfType([arrayOf(oneOf(ACTIVE_TENANTS)), oneOf(ACTIVE_TENANTS)])
      .isRequired,
    publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  }

  static defaultProps = {
    not: false,
  }

  shouldRender() {
    const {
      not,
      tenant,
      publicRuntimeConfig: {
        publicConfig: { tenant: currentTenant },
      },
    } = this.props

    const matches = Array.isArray(tenant)
      ? tenant.includes(currentTenant)
      : tenant === currentTenant

    return matches !== not
  }

  render() {
    if (!this.shouldRender()) {
      return null
    }

    return this.props.children()
  }
}

export default withShopAndRuntimeConfig(Tenant)
